/**
 * Estrategia — GEN-PX-018. Landing del raíl para todos los perfiles (grupo Estrategia · Saber). La cabecera la emite el
 * kernel en el ítem `estrategia` del menú (presidida por Jorge); aquí solo se pinta. El botón abre con Jorge la misma
 * conversación que pulsar su tarjeta (GEN-PX-011), vía `onAbrirAgente`.
 */
import { useCapabilitiesOpcional, useSession } from '../context/SessionContext.jsx'
import { useFotoAgente } from '../context/FotosAgentes.jsx'
import CabeceraLanding from './CabeceraLanding.jsx'

export default function EstrategiaPanel({ onAbrirAgente }) {
  const cab = useCapabilitiesOpcional()?.menu?.find(m => m.id === 'estrategia')?.cabecera
  const { agents } = useSession()
  const fotoDe = useFotoAgente()
  if (!cab) return null
  const ag = cab.agente && (agents.find(a => a.id === cab.agente.id) ?? cab.agente)
  const destino = cab.boton && agents.find(a => a.id === cab.boton.agente_id)
  return (
    <div className="dk-saber">
      <CabeceraLanding
        agente={ag ? { nombre: cab.agente.nombre, rol: cab.agente.rol, foto: fotoDe(ag) } : null}
        titulo={cab.titulo}
        texto={cab.texto}
        boton={destino ? { etiqueta: cab.boton.etiqueta, onClick: () => onAbrirAgente?.(destino) } : null}
      />
    </div>
  )
}
